import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
// optional style for arrows & dots
import VueRouter  from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueRouter)
import router from "./router";
Vue.config.productionTip = false;
Vue.use(BootstrapVue);

import {Swiper as SwiperClass, Pagination, Navigation, Mousewheel, Autoplay} from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'

SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))
// const {Swiper, SwiperSlide} = getAwesomeSwiper(SwiperClass)

// import style
import 'swiper/swiper-bundle.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
// import style
// import 'swiper/swiper-bundle.css'
 
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
